import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/aiDrivenDevelopment/Template'

const AIDrivenDevelopment: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={
          '事例 実績 AI駆動開発 支援 AI エージェント 開発 モダナイゼーション モダンスタック プラットフォームエンジニアリング CI/CD DevOps'
        }
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/cases/ai-driven-development/'}
        title="AI駆動開発支援 | 事例 | i3DESIGN アイスリーデザイン"
        description="AI駆動開発支援サービスの事例を紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default AIDrivenDevelopment
